import { Component } from '@angular/core';
import { ProductBaseComponent } from './product-base.component';

@Component({
    selector: 'app-product[product]',
    template: `
    <div class="pb-2">
      <div class="d-flex justify-content-center align-items-center flex-column position-relative cursor-pointer bg-white rounded-6px product-component" (click)="addToCart(product)">
        <div class="product-item-attributes">
          <div class="product-item-attribute" [class.bg-color-success]="isProductAvailable()"
               [class.bg-color-danger]="!isProductAvailable()">
            <span class="material-icons md-12 product-item-attribute-icon">inventory</span>
            <span class="product-item-attribute-value">{{ product.considersStock ? product.stock : '&#8734;' }}</span>
          </div>
          <div *ngIf="product.hasMultipleVariants" class="product-item-attribute bg-color-secondary">
            <span class="material-icons md-12 product-item-attribute-icon">sell</span>
            <span class="product-item-attribute-value">{{product.variants.length}}</span>
          </div>
        </div>
        <button type="button" (click)="$event.stopPropagation(); openInfo(product.id)" class="info-button text-info">
          <span class="material-icons-outlined">info</span>
        </button>
        <div class="d-block w-88px h-88px w-sm-112px h-sm-112px product-image-placeholder"
          [style.background-image]="product.image && 'url(' + product.image + ')'">
          <div class="w-100 h-100 position-relative bg-transparent">
          </div>
        </div>
        <div class="product-name-wrapper">
          <div class="text-center product-name"
               [style.text-decoration]="isProductAvailable() ? 'none' : 'line-through'">{{ product.title }}
          </div>
        </div>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }
    .product-item-attributes {
      margin: 6px;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }
    .product-item-attribute {
      border-radius: 3px;
      color: #fff;
      display: inline-block;
      font-size: 12.8px;
      font-weight: 600;
      height: 24px;
      margin: 0 4px 0 1px;
      overflow: hidden;

      .product-item-attribute-icon {
        background-size: 12px;
        background-color: rgba(0,0,0,.2);
        background-repeat: no-repeat;
        background-position: center;
        display: block;
        float: left;
        width: 22px;
        height: 24px;
        line-height: 24px !important;
      }

      .product-item-attribute-value {
        display: inline-block;
        line-height: 24px;
        text-align: center;
        padding: 0 8px;
        vertical-align: top;
      }
    }

    .info-button {
      background: 0 0;
      border: 0;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 50px;
      z-index: 1000;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      padding-top: 6px;
    }
    .product-details {
      flex-grow: 0.5;
      -webkit-flex-grow: 0.5;
    }
    .product-info-button {
      transform: translate(50%, 5%);
      position: absolute;
      bottom: 0;
      left: 50%;
    }
    .product-name-wrapper {
      height: 48px;
      width: 100%;
      padding: 5px 10px;
    }
    .product-name {
      height: 100%;
      width: 100%;
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 38px;
      overflow: hidden;
      white-space: nowrap;
    }

    .product-component {
      width: 100%;
      min-width: 160px;
      aspect-ratio: 1 / 1;
    }
  `],
    standalone: false
})
export class ProductComponent extends ProductBaseComponent { }
